(() => {
  const {
    Csv,
    Events,
    CartService,
    UrlService
  } = window.ProductListsServices || {};
  const ATTR_KEY = '_compare_pairs';

  const LS = {
    token: 'cmp:cart_token',
    compare: 'cmp:compare_csv',
    ts: 'cmp:last_ts',
  };

  const nowISO = () => new Date().toISOString();
  const readSnap = () => ({
    token: localStorage.getItem(LS.token) || '',
    compare: Csv?.normalize(localStorage.getItem(LS.compare) || '') || '',
    ts: localStorage.getItem(LS.ts) || ''
  });
  const writeSnap = (token, compare) => {
    try {
      localStorage.setItem(LS.token, token || '');
      localStorage.setItem(LS.compare, Csv?.normalize(compare) || '');
      localStorage.setItem(LS.ts, nowISO());
    } catch {}
  };

  async function bootstrap() {
    if (UrlService?.hasPublicParam?.()) return;

    let cart;
    try {
      cart = await CartService.fetchCart();
    } catch {
      return;
    }

    const token = String(cart?.token || '');
    const attrs = cart?.attributes || {};
    const current = Csv.normalize(attrs[ATTR_KEY] || '');
    const snap = readSnap();

    if (!snap.token) {
      writeSnap(token, current);
      return;
    }

    if (snap.token !== token) {
      const desired = Csv.normalize(snap.compare || '');
      if (desired !== current) {
        await CartService.updateAttributesJSON({
          [ATTR_KEY]: desired
        }).catch(() => {});
        document.dispatchEvent(new CustomEvent(Events?.CHANGE || 'product-lists:change', {
          detail: {
            type: 'restore:ls',
            list: 'compare'
          }
        }));
      }
      writeSnap(token, snap.compare);
      return;
    }

    writeSnap(token, current);
  }

  document.addEventListener('product-lists:change', async (e) => {
    const d = e.detail || {};
    const list = (d.list || d.listName || 'compare').toLowerCase();
    const type = String(d.type || d.source || '').toLowerCase();
    if (!/^(add|remove|clear|import:append|import:replace|replace:csv|remove:group)$/.test(type)) return;
    if (list !== 'compare') return;
    if (UrlService?.hasPublicParam?.()) return;

    try {
      const cart = await CartService.fetchCart();
      const token = String(cart?.token || '');
      const attrs = cart?.attributes || {};
      const snapCompare = Csv.normalize(attrs[ATTR_KEY] || '');
      writeSnap(token, snapCompare);
    } catch {}
  });

  (async () => {
    try {
      await bootstrap();
    } catch {}
  })();
})();